/** Expiration options for API key creation. Values must be within the backend's 1–365 day range. */
export const API_KEY_EXPIRY_OPTIONS = [
  { value: "none", label: "No expiration" },
  { value: "30", label: "30 days" },
  { value: "60", label: "60 days" },
  { value: "90", label: "90 days" },
  { value: "180", label: "180 days" },
  { value: "365", label: "1 year" },
] as const;
